// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__2_4Tb","buttons":"Password_buttons__29by8"};